/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/en_GB';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Access the pretty HTML editor"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Accessibility Checker"
  },
  "action_to_take_b626a99a": {
    "message": "Action to take:"
  },
  "add_8523c19b": {
    "message": "Add"
  },
  "add_a_caption_2a915239": {
    "message": "Add a caption"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Add alt text for the image"
  },
  "add_another_f4e50d57": {
    "message": "Add another"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Add CC/Subtitles"
  },
  "add_image_60b2de07": {
    "message": "Add Image"
  },
  "add_one_9e34a6f8": {
    "message": "Add one!"
  },
  "additional_considerations_f3801683": {
    "message": "Additional considerations"
  },
  "address_applied_64269b0b": {
    "message": "Address applied"
  },
  "address_removed_fcb496e0": {
    "message": "Address removed"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Adjacent links with the same URL should be a single link."
  },
  "ai_response_9624e8e8": {
    "message": "AI Response"
  },
  "ai_tools_fda01177": {
    "message": "AI Tools"
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Align"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Alignment and Lists"
  },
  "all_4321c3a1": {
    "message": "All"
  },
  "all_apps_a50dea49": {
    "message": "All Apps"
  },
  "alpha_15d59033": {
    "message": "Alpha"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alphabetical"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Alt attribute text should not contain more than 120 characters."
  },
  "alt_text_611fb322": {
    "message": "Alt Text"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Coproduct)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "An error occured reading the file"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "An error occurred making a network request"
  },
  "an_error_occurred_processing_your_request_a3a38d84": {
    "message": "An error occurred processing your request"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "An error occurred uploading your media."
  },
  "and_7fcc2911": {
    "message": "And"
  },
  "angle_c5b4ec50": {
    "message": "Angle"
  },
  "announcement_fb4cb645": {
    "message": "Announcement"
  },
  "announcement_list_da155734": {
    "message": "Announcement List"
  },
  "announcements_a4b8ed4a": {
    "message": "Announcements"
  },
  "apply_781a2546": {
    "message": "Apply"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Apply changes to all instances of this Icon Maker Icon in the Course"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Approaches the Limit"
  },
  "approximately_e7965800": {
    "message": "Approximately"
  },
  "apps_54d24a47": {
    "message": "Apps"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Are you sure you want to cancel? Changes you made may not be saved."
  },
  "arrows_464a3e54": {
    "message": "Arrows"
  },
  "art_icon_8e1daad": {
    "message": "Art Icon"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Aspect ratio will be preserved"
  },
  "assignment_976578a8": {
    "message": "Assignment"
  },
  "assignments_1e02582c": {
    "message": "Assignments"
  },
  "asterisk_82255584": {
    "message": "Asterisk"
  },
  "attributes_963ba262": {
    "message": "Attributes"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Audio and video recording not supported; please use a different browser."
  },
  "audio_options_feb58e2c": {
    "message": "Audio Options"
  },
  "audio_options_tray_33a90711": {
    "message": "Audio Options Tray"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Audio player for { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Auto-saved content exists. Would you like to load the auto-saved content instead?"
  },
  "available_folders_694d0436": {
    "message": "Available folders"
  },
  "background_1bc88842": {
    "message": "Background"
  },
  "backslash_b2d5442d": {
    "message": "Backslash"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Basic"
  },
  "because_501841b": {
    "message": "Because"
  },
  "below_81d4dceb": {
    "message": "Below"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Big Circle"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binomial Coefficient"
  },
  "black_4cb01371": {
    "message": "Black"
  },
  "blue_daf8fea9": {
    "message": "Blue"
  },
  "bold_applied_42d547b7": {
    "message": "Bold applied"
  },
  "bold_removed_da474a5c": {
    "message": "Bold removed"
  },
  "border_5b08b06d": {
    "message": "Border"
  },
  "bottom_15a2a9be": {
    "message": "Bottom"
  },
  "bottom_third_5f5fec1d": {
    "message": "Bottom Third"
  },
  "bowtie_5f9629e4": {
    "message": "Bowtie"
  },
  "brick_f2656265": {
    "message": "Brick"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Cancel"
  },
  "cap_product_3a5265a6": {
    "message": "Cap Product"
  },
  "center_align_e68d9997": {
    "message": "Centre Align"
  },
  "centered_dot_64d5e378": {
    "message": "Centred Dot"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Centred Horizontal Dots"
  },
  "change_alt_text_92654906": {
    "message": "Change alt text"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Change heading tag to paragraph"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Change only this heading''s level"
  },
  "change_text_color_1aecb912": {
    "message": "Change text colour"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Changes you made may not be saved."
  },
  "characters_9d897d1c": {
    "message": "Characters"
  },
  "characters_no_spaces_485e5367": {
    "message": "Characters (no spaces)"
  },
  "check_accessibility_3c78211c": {
    "message": "Check Accessibility"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Checking for accessibility issues"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Choose caption file"
  },
  "choose_usage_rights_33683854": {
    "message": "Choose usage rights..."
  },
  "circle_484abe63": {
    "message": "Circle"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "circle unordered list"
  },
  "clear_2084585f": {
    "message": "Clear"
  },
  "clear_image_3213fe62": {
    "message": "Clear image"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Click or shift-click for the html editor."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Click to embed { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Click to hide preview"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Click to insert a link into the editor."
  },
  "click_to_show_preview_faa27051": {
    "message": "Click to show preview"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Close a menu or dialogue. Also returns you to the editor area"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Close Accessibility Checker"
  },
  "close_d634289d": {
    "message": "Close"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Closed caption file must be less than { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Closed Captions/Subtitles"
  },
  "clubs_suit_c1ffedff": {
    "message": "Clubs (Suit)"
  },
  "collaborations_5c56c15f": {
    "message": "Collaborations"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Collapse to hide { types }"
  },
  "color_a363e1b0": {
    "message": "Colour"
  },
  "color_contrast_4c418add": {
    "message": "Colour Contrast"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Colour Contrast Ratio"
  },
  "color_picker_6b359edf": {
    "message": "Colour Picker"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Colour Picker ({ colorName } selected)"
  },
  "color_popup_af39810f": {
    "message": "Colour popup"
  },
  "column_e1ae5c64": {
    "message": "Column"
  },
  "column_group_1c062368": {
    "message": "Column group"
  },
  "complex_numbers_a543d004": {
    "message": "Complex Numbers"
  },
  "compose_44c904f4": {
    "message": "Compose"
  },
  "computer_1d7dfa6f": {
    "message": "Computer"
  },
  "congruent_5a244acd": {
    "message": "Congruent"
  },
  "contains_311f37b7": {
    "message": "Contains"
  },
  "content_1440204b": {
    "message": "Content"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Content in the editor will be changed. Press Cancel to keep the original content."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Content is still being uploaded, if you continue it will not be embedded properly."
  },
  "content_subtype_5ce35e88": {
    "message": "Content Subtype"
  },
  "content_type_2cf90d95": {
    "message": "Content Type"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Continue to YouTube content"
  },
  "coproduct_e7838082": {
    "message": "Coproduct"
  },
  "copy_9748f9f": {
    "message": "Copy"
  },
  "copyright_holder_66ee111": {
    "message": "Copyright Holder:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Could not insert content: \"{ itemType }\" items are not currently supported in Canvas."
  },
  "count_40eced3b": {
    "message": "Count"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 words}\n    one {1 word}\n  other {# words}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# item loaded}\n  other {# items loaded}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Course Documents"
  },
  "course_files_62deb8f8": {
    "message": "Course Files"
  },
  "course_files_a31f97fc": {
    "message": "Course files"
  },
  "course_images_f8511d04": {
    "message": "Course Images"
  },
  "course_link_b369426": {
    "message": "Course Link"
  },
  "course_links_b56959b9": {
    "message": "Course Links"
  },
  "course_media_ec759ad": {
    "message": "Course Media"
  },
  "course_navigation_dd035109": {
    "message": "Course Navigation"
  },
  "create_icon_110d6463": {
    "message": "Create Icon"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Create Icon Maker Icon"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons Licence:"
  },
  "crop_image_41bf940c": {
    "message": "Crop image"
  },
  "crop_image_807ebb08": {
    "message": "Crop Image"
  },
  "cup_product_14174434": {
    "message": "Cup Product"
  },
  "current_image_f16c249c": {
    "message": "Current Image"
  },
  "current_link_945a47ee": {
    "message": "Current Link"
  },
  "current_volume_level_c55ab825": {
    "message": "Current Volume Level"
  },
  "custom_6979cd81": {
    "message": "Custom"
  },
  "custom_width_and_height_pixels_946eea7c": {
    "message": "Custom width and height (Pixels)"
  },
  "cyan_c1d5f68a": {
    "message": "Cyan"
  },
  "dagger_57e0f4e5": {
    "message": "Dagger"
  },
  "date_added_ed5ad465": {
    "message": "Date Added"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Decorative Icon"
  },
  "decorative_image_fde98579": {
    "message": "Decorative image"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Decorative { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Decrease Indent"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Decrease Rich Content Area"
  },
  "deep_purple_bb3e2907": {
    "message": "Deep Purple"
  },
  "default_9db103d": {
    "message": "Default"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "default bulleted unordered list"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "default numerical ordered list"
  },
  "definite_integral_fe7ffed1": {
    "message": "Definite Integral"
  },
  "degree_symbol_4a823d5f": {
    "message": "Degree Symbol"
  },
  "delimiters_4db4840d": {
    "message": "Delimiters"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Describe the icon)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Describe the { TYPE })"
  },
  "describe_the_video_2fe8f46a": {
    "message": "(Describe the video)"
  },
  "description_436c48d7": {
    "message": "Description"
  },
  "details_98a31b68": {
    "message": "Details"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Diagonal Dots"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamond"
  },
  "diamonds_suit_526abaaf": {
    "message": "Diamonds (Suit)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Dimension Type"
  },
  "dimensions_45ddb7b7": {
    "message": "Dimensions"
  },
  "directionality_26ae9e08": {
    "message": "Directionality"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Directly Edit LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Disable Preview"
  },
  "discussion_6719c51d": {
    "message": "Discussion"
  },
  "discussions_a5f96392": {
    "message": "Discussions"
  },
  "discussions_index_6c36ced": {
    "message": "Discussions Index"
  },
  "disjoint_union_e74351a8": {
    "message": "Disjoint Union"
  },
  "dislike_14befc48": {
    "message": "Dislike"
  },
  "display_options_315aba85": {
    "message": "Display Options"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Display Text Link (Opens in a new tab)"
  },
  "div_applied_49ad83fc": {
    "message": "Div applied"
  },
  "div_removed_d13f8e17": {
    "message": "Div removed"
  },
  "division_sign_72190870": {
    "message": "Division Sign"
  },
  "document_678cd7bf": {
    "message": "Document"
  },
  "documents_81393201": {
    "message": "Documents"
  },
  "done_54e3d4b6": {
    "message": "Done"
  },
  "double_dagger_faf78681": {
    "message": "Double Dagger"
  },
  "down_5831a426": {
    "message": "Down"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Down And Left Diagonal Arrow"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Down And Right Diagonal Arrow"
  },
  "download_filename_2baae924": {
    "message": "Download { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Downward Arrow"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Downward Pointing Triangle"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Drag a file here"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Drag and drop, or click to browse your computer"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Drag handle. Use up and down arrows to resize"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Due: Multiple Dates"
  },
  "due_when_7eed10c6": {
    "message": "Due: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Edit alt text for this icon instance"
  },
  "edit_c5fbea07": {
    "message": "Edit"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Edit Course Link"
  },
  "edit_equation_f5279959": {
    "message": "Edit Equation"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Edit Existing Icon Maker Icon"
  },
  "edit_icon_2c6b0e91": {
    "message": "Edit Icon"
  },
  "edit_link_7f53bebb": {
    "message": "Edit Link"
  },
  "editor_status_bar_653f44ee": {
    "message": "Editor Status Bar"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Element starting with { start }"
  },
  "embed_828fac4a": {
    "message": "Embed"
  },
  "embed_code_314f1bd5": {
    "message": "Embed Code"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Embed content from External Tool"
  },
  "embed_image_1080badc": {
    "message": "Embed Image"
  },
  "embed_video_a97a64af": {
    "message": "Embed Video"
  },
  "embedded_content_aaeb4d3d": {
    "message": "embedded content"
  },
  "empty_set_91a92df4": {
    "message": "Empty Set"
  },
  "encircled_dot_8f5e51c": {
    "message": "Encircled Dot"
  },
  "encircled_minus_72745096": {
    "message": "Encircled Minus"
  },
  "encircled_plus_36d8d104": {
    "message": "Encircled Plus"
  },
  "encircled_times_5700096d": {
    "message": "Encircled Times"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Engineering Icon"
  },
  "english_icon_25bfe845": {
    "message": "English Icon"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Enter at least 3 characters to search"
  },
  "enter_replacement_text_17631bbc": {
    "message": "enter replacement text"
  },
  "enter_search_text_26cb4459": {
    "message": "enter search text"
  },
  "enter_text_8b35c65b": {
    "message": "Enter text"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Variant)"
  },
  "equals_sign_c51bdc58": {
    "message": "Equals Sign"
  },
  "equation_1c5ac93c": {
    "message": "Equation"
  },
  "equation_editor_39fbc3f1": {
    "message": "Equation Editor"
  },
  "equilibrium_6ff3040b": {
    "message": "Equilibrium"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Equivalence Class"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Equivalent (Identity)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Exists"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Exit Fullscreen"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Expand preview by Default"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Expand to see { types }"
  },
  "external_link_d3f9e62a": {
    "message": "External Link"
  },
  "external_tool_frame_70b32473": {
    "message": "External tool frame"
  },
  "external_tools_6e77821": {
    "message": "External Tools"
  },
  "extra_large_b6cdf1ff": {
    "message": "Extra Large"
  },
  "extra_small_9ae33252": {
    "message": "Extra Small"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Extracurricular Icon"
  },
  "f_function_fe422d65": {
    "message": "F (function)"
  },
  "fail_544e5dde": {
    "message": "FAIL"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Failed getting file contents"
  },
  "failed_to_copy_response_d3def551": {
    "message": "Failed to copy response"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Failed to retrieve content from external tool"
  },
  "file_name_8fd421ff": {
    "message": "File name"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "File storage quota exceeded"
  },
  "file_url_c12b64be": {
    "message": "File URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } file icon"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } image preview"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } text preview"
  },
  "files_c300e900": {
    "message": "Files"
  },
  "files_index_af7c662b": {
    "message": "Files Index"
  },
  "find_8d605019": {
    "message": "Find"
  },
  "find_and_replace_6e345933": {
    "message": "Find and Replace"
  },
  "finish_bc343002": {
    "message": "Finish"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Fix heading hierarchy"
  },
  "flat_music_76d5a5c3": {
    "message": "Flat (Music)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Focus element options toolbar"
  },
  "folder_tree_fbab0726": {
    "message": "Folder tree"
  },
  "for_all_b919f972": {
    "message": "For All"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Format as a list"
  },
  "formatting_5b143aa8": {
    "message": "Formatting"
  },
  "forward_slash_3f90f35e": {
    "message": "Forward Slash"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Found auto-saved content"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Found { count, plural,\n     =0 {# results}\n    one {# result}\n  other {# results}\n}"
  },
  "fraction_41bac7af": {
    "message": "Fraction"
  },
  "fullscreen_873bf53f": {
    "message": "Fullscreen"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Generating preview..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "GIF/PNG format images larger than { size } KB are not currently supported."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Go to the editor''s menubar"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Go to the editor''s toolbar"
  },
  "grades_a61eba0a": {
    "message": "Marks"
  },
  "graphics_text_bc9568bc": {
    "message": "Graphics text"
  },
  "greater_than_e98af662": {
    "message": "Greater Than"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Greater Than Or Equal"
  },
  "greek_65c5b3f7": {
    "message": "Greek"
  },
  "green_15af4778": {
    "message": "Green"
  },
  "grey_a55dceff": {
    "message": "Grey"
  },
  "group_documents_8bfd6ae6": {
    "message": "Group Documents"
  },
  "group_files_4324f3df": {
    "message": "Group Files"
  },
  "group_files_82e5dcdb": {
    "message": "Group files"
  },
  "group_images_98e0ac17": {
    "message": "Group Images"
  },
  "group_isomorphism_45b1458c": {
    "message": "Group Isomorphism"
  },
  "group_link_63e626b3": {
    "message": "Group Link"
  },
  "group_links_9493129e": {
    "message": "Group Links"
  },
  "group_media_2f3d128a": {
    "message": "Group Media"
  },
  "group_navigation_99f191a": {
    "message": "Group Navigation"
  },
  "h_bar_bb94deae": {
    "message": "H Bar"
  },
  "hat_ea321e35": {
    "message": "Hat"
  },
  "header_column_f27433cb": {
    "message": "Header column"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Header row and column"
  },
  "header_row_f33eb169": {
    "message": "Header row"
  },
  "heading_2_5b84eed2": {
    "message": "Heading 2"
  },
  "heading_3_2c83de44": {
    "message": "Heading 3"
  },
  "heading_4_b2e74be7": {
    "message": "Heading 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Heading { h } applied"
  },
  "heading_h_removed_745f24a6": {
    "message": "Heading { h } removed"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Heading levels should not be skipped."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Heading starting with { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Headings should not contain more than 120 characters."
  },
  "health_icon_8d292eb5": {
    "message": "Health Icon"
  },
  "hearts_suit_e50e04ca": {
    "message": "Hearts (Suit)"
  },
  "height_69b03e15": {
    "message": "Height"
  },
  "hello_please_describe_the_modifications_you_would__49b19837": {
    "message": "Hello. Please describe the modifications you would like to make to your composition."
  },
  "hello_please_describe_the_modifications_you_would__600dbbf0": {
    "message": "Hello. Please describe the modifications you would like to make to your selection."
  },
  "hexagon_d8468e0d": {
    "message": "Hexagon"
  },
  "hide_description_bfb5502e": {
    "message": "Hide description"
  },
  "hide_title_description_caf092ef": {
    "message": "Hide { title } description"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Highlight an element to activate the element options toolbar"
  },
  "home_351838cd": {
    "message": "Home"
  },
  "html_code_editor_fd967a44": {
    "message": "html code editor"
  },
  "html_editor_fb2ab713": {
    "message": "HTML Editor"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "I have obtained permission to use this file."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "I hold the copyright"
  },
  "i_m_sorry_but_i_cannot_find_the_ai_s_answer_67569d19": {
    "message": "I''m sorry, but I cannot find the AI''s answer"
  },
  "icon_215a1dc6": {
    "message": "Icon"
  },
  "icon_8168b2f8": {
    "message": "icon"
  },
  "icon_color_b86dd6d6": {
    "message": "Icon Colour"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Icon Maker Icons"
  },
  "icon_options_7e32746e": {
    "message": "Icon Options"
  },
  "icon_options_tray_2b407977": {
    "message": "Icon Options Tray"
  },
  "icon_preview_1782a1d9": {
    "message": "Icon Preview"
  },
  "icon_shape_30b61e7": {
    "message": "Icon Shape"
  },
  "icon_size_9353edea": {
    "message": "Icon Size"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "If left empty, link text will display as course link name"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "If Usage Rights are required, the file will not publish until enabled in the Files page."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "If you do not select usage rights now, this file will be unpublished after it''s uploaded."
  },
  "image_8ad06": {
    "message": "Image"
  },
  "image_c1c98202": {
    "message": "image"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Image filenames should not be used as the alt attribute describing the image content."
  },
  "image_options_5412d02c": {
    "message": "Image Options"
  },
  "image_options_tray_90a46006": {
    "message": "Image Options Tray"
  },
  "image_to_crop_3a34487d": {
    "message": "Image to crop"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Image with filename { file }"
  },
  "images_7ce26570": {
    "message": "Images"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Images should include an alt attribute describing the image content."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Imaginary Portion (of Complex Number)"
  },
  "in_element_of_19ca2f33": {
    "message": "In (Element Of)"
  },
  "increase_indent_6af90f7c": {
    "message": "Increase Indent"
  },
  "increase_rich_content_area_340b775": {
    "message": "Increase Rich Content Area"
  },
  "indefinite_integral_6623307e": {
    "message": "Indefinite Integral"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } of { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Inference"
  },
  "infinity_7a10f206": {
    "message": "Infinity"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Input field for alpha"
  },
  "input_field_for_blue_561e020a": {
    "message": "Input field for blue"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Input field for green"
  },
  "input_field_for_red_86a84615": {
    "message": "Input field for red"
  },
  "insert_593145ef": {
    "message": "Insert"
  },
  "insert_link_6dc23cae": {
    "message": "Insert Link"
  },
  "insert_math_equation_57c6e767": {
    "message": "Insert Maths Equation"
  },
  "integers_336344e1": {
    "message": "Integers"
  },
  "intersection_cd4590e4": {
    "message": "Intersection"
  },
  "invalid_description_991e23bb": {
    "message": "Invalid description"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Invalid entry."
  },
  "invalid_file_c11ba11": {
    "message": "Invalid File"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Invalid file type"
  },
  "invalid_url_cbde79f": {
    "message": "Invalid URL"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Issue { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Italic applied"
  },
  "italic_removed_17cbab6f": {
    "message": "Italic removed"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Variant)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Keyboard Shortcuts"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Keyboards navigate to links using the Tab key. Two adjacent links that direct to the same destination can be confusing to keyboard users."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Language Arts Icon"
  },
  "languages_icon_9d20539": {
    "message": "Languages Icon"
  },
  "large_9c5e80e7": {
    "message": "Large"
  },
  "large_text_e7ba08cd": {
    "message": "Large text"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Learn more about adjacent links"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Learn more about colour contrast"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Learn more about organising page headings"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Learn more about proper page heading structure"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Learn more about table headers"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Learn more about using alt text for images"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Learn more about using captions with tables"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Learn more about using filenames as alt text"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Learn more about using lists"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Learn more about using scope attributes with tables"
  },
  "leave_as_is_4facfe55": {
    "message": "Leave as is"
  },
  "left_3ea9d375": {
    "message": "Left"
  },
  "left_align_43d95491": {
    "message": "Left Align"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Left Angle Bracket"
  },
  "left_arrow_4fde1a64": {
    "message": "Left Arrow"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Left Arrow With Hook"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Left Ceiling"
  },
  "left_curly_brace_1726fb4": {
    "message": "Left Curly Brace"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Left Downard Harpoon Arrow"
  },
  "left_floor_29ac2274": {
    "message": "Left Floor"
  },
  "left_to_right_e9b4fd06": {
    "message": "Left-to-Right"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Left Upward Harpoon Arrow"
  },
  "leftward_arrow_1e4765de": {
    "message": "Leftward Arrow"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Leftward Pointing Triangle"
  },
  "less_than_a26c0641": {
    "message": "Less Than"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Less Than Or Equal"
  },
  "library_icon_ae1e54cf": {
    "message": "Library Icon"
  },
  "light_blue_5374f600": {
    "message": "Light Blue"
  },
  "link_7262adec": {
    "message": "Link"
  },
  "link_options_a16b758b": {
    "message": "Link Options"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "link type: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Link with text starting with { start }"
  },
  "links_14b70841": {
    "message": "Links"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Links to an external site."
  },
  "lists_cd1336fc": {
    "message": "Lists"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Lists should be formatted as lists."
  },
  "load_more_35d33c7": {
    "message": "Load More"
  },
  "loading_25990131": {
    "message": "Loading..."
  },
  "loading_bde52856": {
    "message": "Loading"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "loading closed captions/subtitles failed."
  },
  "loading_external_tool_d839042c": {
    "message": "Loading External Tool"
  },
  "loading_failed_b3524381": {
    "message": "Loading failed..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Loading failed."
  },
  "loading_folders_d8b5869e": {
    "message": "Loading folders"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Loading placeholder for { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Loading, please wait"
  },
  "loading_preview_9f077aa1": {
    "message": "Loading preview"
  },
  "locked_762f138b": {
    "message": "Locked"
  },
  "logical_equivalence_76fca396": {
    "message": "Logical Equivalence"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Logical Equivalence (Short)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Logical Equivalence (Short And Thick)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Logical Equivalence (Thick)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Low Horizontal Dots"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Maps To"
  },
  "math_icon_ad4e9d03": {
    "message": "Math Icon"
  },
  "media_af190855": {
    "message": "Media"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Media file is processing. Please try again later."
  },
  "media_title_2112243b": {
    "message": "Media Title"
  },
  "medium_5a8e9ead": {
    "message": "Medium"
  },
  "merge_links_2478df96": {
    "message": "Merge links"
  },
  "mic_a7f3d311": {
    "message": "Mic"
  },
  "microphone_disabled_15c83130": {
    "message": "Microphone Disabled"
  },
  "middle_27dc1d5": {
    "message": "Middle"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimise File Preview"
  },
  "minimize_video_20aa554b": {
    "message": "Minimise Video"
  },
  "minus_fd961e2e": {
    "message": "Minus"
  },
  "minus_plus_3461f637": {
    "message": "Minus/Plus"
  },
  "misc_3b692ea7": {
    "message": "Misc"
  },
  "miscellaneous_e9818229": {
    "message": "Miscellaneous"
  },
  "modify_6b0b13e3": {
    "message": "Modify"
  },
  "module_90d9fd32": {
    "message": "Module"
  },
  "modules_c4325335": {
    "message": "Modules"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Moving image to crop { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Multi Colour Image"
  },
  "multiplication_sign_15f95c22": {
    "message": "Multiplication Sign"
  },
  "music_icon_4db5c972": {
    "message": "Music Icon"
  },
  "my_files_2f621040": {
    "message": "My files"
  },
  "n_th_root_9991a6e4": {
    "message": "N-th Root"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Name"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Natural (Music)"
  },
  "natural_numbers_3da07060": {
    "message": "Natural Numbers"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navigate through the menu or toolbar"
  },
  "navigation_ee9af92d": {
    "message": "Navigation"
  },
  "nested_greater_than_d852e60d": {
    "message": "Nested Greater Than"
  },
  "nested_less_than_27d17e58": {
    "message": "Nested Less Than"
  },
  "new_quiz_34aacba6": {
    "message": "New Quiz"
  },
  "next_40e12421": {
    "message": "Next"
  },
  "next_findtext_9d69f0fe": {
    "message": "Next { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "No accessibility issues were detected."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "No announcements created yet."
  },
  "no_announcements_found_20185afc": {
    "message": "No announcements found."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "No assignments created yet."
  },
  "no_assignments_found_79e46d7f": {
    "message": "No assignments found."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "No changes to save."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "No discussions created yet."
  },
  "no_discussions_found_9284063b": {
    "message": "No discussions found."
  },
  "no_e16d9132": {
    "message": "No"
  },
  "no_file_chosen_9a880793": {
    "message": "No file chosen"
  },
  "no_headers_9bc7dc7f": {
    "message": "No headers"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "No modules created yet."
  },
  "no_modules_found_2df43a40": {
    "message": "No modules found."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "No pages created yet."
  },
  "no_pages_found_6799350": {
    "message": "No pages found."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "No preview is available for this file."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "No quizzes created yet."
  },
  "no_quizzes_found_c80c537a": {
    "message": "No quizzes found."
  },
  "no_results_940393cf": {
    "message": "No results."
  },
  "no_results_found_58717065": {
    "message": "No results found"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "No results found for { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "No Video"
  },
  "none_3b5e34d2": {
    "message": "None"
  },
  "none_selected_b93d56d2": {
    "message": "None Selected"
  },
  "normal_text_7b03da48": {
    "message": "Normal text"
  },
  "not_equal_6e2980e6": {
    "message": "Not Equal"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Not In (Not An Element Of)"
  },
  "not_negation_1418ebb8": {
    "message": "Not (Negation)"
  },
  "not_subset_dc2b5e84": {
    "message": "Not Subset"
  },
  "not_subset_strict_23d282bf": {
    "message": "Not Subset (Strict)"
  },
  "not_superset_5556b913": {
    "message": "Not Superset"
  },
  "not_superset_strict_24e06f36": {
    "message": "Not Superset (Strict)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Octagon"
  },
  "olive_6a3e4d6b": {
    "message": "Olive"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "One of the following styles must be added to save an icon: Icon Colour, Outline Size, Icon Text, or Image"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "One or more files failed to paste. Please try uploading or dragging and dropping files."
  },
  "open_circle_e9bd069": {
    "message": "Open Circle"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Open this keyboard shortcuts dialog"
  },
  "open_title_application_fd624fc5": {
    "message": "Open { title } application"
  },
  "operators_a2ef9a93": {
    "message": "Operators"
  },
  "or_9b70ccaa": {
    "message": "Or"
  },
  "orange_81386a62": {
    "message": "Orange"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Ordered and Unordered Lists"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Other editor shortcuts may be found at"
  },
  "outline_color_3ef2cea7": {
    "message": "Outline Colour"
  },
  "outline_size_a6059a21": {
    "message": "Outline Size"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } is not a valid protocol."
  },
  "page_50c4823d": {
    "message": "Page"
  },
  "pages_e5414c2c": {
    "message": "Pages"
  },
  "paragraph_5e5ad8eb": {
    "message": "Paragraph"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Paragraph applied"
  },
  "paragraph_removed_d09320e": {
    "message": "Paragraph removed"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Paragraph starting with { start }"
  },
  "parallel_d55d6e38": {
    "message": "Parallel"
  },
  "partial_derivative_4a9159df": {
    "message": "Partial (Derivative)"
  },
  "pass_1c19a2b3": {
    "message": "PASS"
  },
  "paste_5963d1c1": {
    "message": "Paste"
  },
  "pause_12af3bb4": {
    "message": "Pause"
  },
  "pentagon_17d82ea3": {
    "message": "Pentagon"
  },
  "people_b4ebb13c": {
    "message": "People"
  },
  "percentage_34ab7c2c": {
    "message": "Percentage"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Percentage must be a number"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Percentage must be at least { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Performing Arts Icon"
  },
  "perpendicular_7c48ede4": {
    "message": "Perpendicular"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Variant)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Physical Education Icon"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Variant)"
  },
  "pick_a_color_557abfb0": {
    "message": "Pick a colour"
  },
  "pink_68ad45cb": {
    "message": "Pink"
  },
  "pixels_52ece7d1": {
    "message": "Pixels"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Pixels must be at least { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Play"
  },
  "play_media_comment_35257210": {
    "message": "Play media comment."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Play media comment by { name } from { createdAt }."
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Please allow Canvas to access your microphone and webcam."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Please choose a file"
  },
  "please_decribe_what_you_would_like_to_compose_27a51be5": {
    "message": "Please describe what you would like to compose."
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Please enter a file name."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Please select a file of a supported type"
  },
  "plus_d43cd4ec": {
    "message": "Plus"
  },
  "plus_minus_f8be2e83": {
    "message": "Plus/Minus"
  },
  "posted_when_a578f5ab": {
    "message": "Posted: { when }"
  },
  "power_set_4f26f316": {
    "message": "Power Set"
  },
  "precedes_196b9aef": {
    "message": "Precedes"
  },
  "precedes_equal_20701e84": {
    "message": "Precedes Equal"
  },
  "preformatted_d0670862": {
    "message": "Preformatted"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Prev"
  },
  "preview_53003fd2": {
    "message": "Preview"
  },
  "preview_a3f8f854": {
    "message": "PREVIEW"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Preview in overlay"
  },
  "preview_inline_9787330": {
    "message": "Preview inline"
  },
  "previous_bd2ac015": {
    "message": "Previous"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Previous { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Previously chosen colours"
  },
  "prime_917ea60e": {
    "message": "Prime"
  },
  "prime_numbers_13464f61": {
    "message": "Prime Numbers"
  },
  "product_39cf144f": {
    "message": "Product"
  },
  "proportional_f02800cc": {
    "message": "Proportional"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protocol must be ftp, http, https, mailto, skype, tel or may be omitted"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "published"
  },
  "published_when_302d8e23": {
    "message": "Published: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Pumpkin"
  },
  "purple_7678a9fc": {
    "message": "Purple"
  },
  "quaternions_877024e0": {
    "message": "Quaternions"
  },
  "quiz_e0dcce8f": {
    "message": "Quiz"
  },
  "quizzes_7e598f57": {
    "message": "Quizzes"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Rational Numbers"
  },
  "real_numbers_7c99df94": {
    "message": "Real Numbers"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Real Portion (of Complex Number)"
  },
  "record_7c9448b": {
    "message": "Record"
  },
  "record_upload_media_5fdce166": {
    "message": "Record/Upload Media"
  },
  "recording_98da6bda": {
    "message": "Recording"
  },
  "red_8258edf3": {
    "message": "Red"
  },
  "relationships_6602af70": {
    "message": "Relationships"
  },
  "religion_icon_246e0be1": {
    "message": "Religion Icon"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Remove heading style"
  },
  "remove_link_d1f2f4d0": {
    "message": "Remove Link"
  },
  "replace_all_d3d68b3": {
    "message": "Replace All"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Replace all { findText } with { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Replace"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Replace { findText } with { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Replace with"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Replaced { alertFindText } with { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Replaced all { alertFindText } with { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Reset"
  },
  "resize_ec83d538": {
    "message": "Resize"
  },
  "response_copied_to_clipboard_130d66cd": {
    "message": "Response copied to clipboard"
  },
  "restore_auto_save_deccd84b": {
    "message": "Restore auto-save?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Result { index } of { max }."
  },
  "retry_ebd5f8ba": {
    "message": "Retry"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Reverse Turnstile (Does Not Yield)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Variant)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Rich Content Editor"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Rich Text Area. Press { OSKey }+F8 for Rich Content Editor shortcuts."
  },
  "right_71ffdc4d": {
    "message": "Right"
  },
  "right_align_39e7a32a": {
    "message": "Right Align"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Right Angle Bracket"
  },
  "right_arrow_35e0eddf": {
    "message": "Right Arrow"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Right Arrow With Hook"
  },
  "right_ceiling_839dc744": {
    "message": "Right Ceiling"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Right Curly Brace"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Right Downward Harpoon Arrow"
  },
  "right_floor_5392d5cf": {
    "message": "Right Floor"
  },
  "right_to_left_9cfb092a": {
    "message": "Right-to-Left"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Right Upward Harpoon Arrow"
  },
  "rightward_arrow_32932107": {
    "message": "Rightward Arrow"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Rightward Pointing Triangle"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Rotate image -90 degrees"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Rotate image 90 degrees"
  },
  "rotation_9699c538": {
    "message": "Rotation"
  },
  "row_fc0944a7": {
    "message": "Row"
  },
  "row_group_979f5528": {
    "message": "Row group"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Sadly, the pretty HTML editor is not keyboard accessible. Access the raw HTML editor here."
  },
  "save_11a80ec3": {
    "message": "Save"
  },
  "save_copy_ca63944e": {
    "message": "Save Copy"
  },
  "save_media_cb9e786e": {
    "message": "Save Media"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Saved Icon Maker Icons"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Screen readers cannot determine what is displayed in an image without alternative text, and filenames are often meaningless strings of numbers and letters that do not describe the context or meaning."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Screen readers cannot determine what is displayed in an image without alternative text that describes the content and meaning of the image. Alternative text should be simple and concise."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Screen readers cannot determine what is displayed in an image without alternative text that describes the content and meaning of the image."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Screen readers cannot interpret tables without the proper structure. Table headers provide direction and content scope."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Screen readers cannot interpret tables without the proper structure. Table captions describe the context and general understanding of the table."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Screen readers cannot interpret tables without the proper structure. Table headers provide direction and overview of the content."
  },
  "script_l_42a7b254": {
    "message": "Script L"
  },
  "search_280d00bd": {
    "message": "Search"
  },
  "select_audio_source_21043cd5": {
    "message": "Select audio source"
  },
  "select_crop_shape_d441feeb": {
    "message": "Select crop shape"
  },
  "select_language_7c93a900": {
    "message": "Select Language"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Select video source"
  },
  "selected_274ce24f": {
    "message": "Selected"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Selected { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Selection"
  },
  "set_header_scope_8c548f40": {
    "message": "Set header scope"
  },
  "set_minus_b46e9b88": {
    "message": "Set Minus"
  },
  "set_table_header_cfab13a0": {
    "message": "Set table header"
  },
  "sharp_music_ab956814": {
    "message": "Sharp (Music)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Arrows"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O to open the pretty html editor."
  },
  "shortcut_911d6255": {
    "message": "Shortcut"
  },
  "show_all_967a90f0": {
    "message": "Show all."
  },
  "show_audio_options_b489926b": {
    "message": "Show audio options"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Show image options"
  },
  "show_link_options_545338fd": {
    "message": "Show link options"
  },
  "show_studio_media_options_a0c748c6": {
    "message": "Show Studio media options"
  },
  "show_video_options_6ed3721a": {
    "message": "Show video options"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Sighted users browse web pages quickly, looking for large or bolded headings. Screen reader users rely on headers for contextual understanding. Headers should use the proper structure."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Sighted users browse web pages quickly, looking for large or bolded headings. Screen reader users rely on headers for contextual understanding. Headers should be concise within the proper structure."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Variant)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Single Colour Image"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Single Colour Image Colour"
  },
  "size_b30e1077": {
    "message": "Size"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Size of caption file is greater than the maximum { max } kb allowed file size."
  },
  "small_b070434a": {
    "message": "Small"
  },
  "solid_circle_9f061dfc": {
    "message": "Solid Circle"
  },
  "something_went_wrong_89195131": {
    "message": "Something went wrong."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Something went wrong accessing your webcam."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Something went wrong and I don''t know what to show you."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Something went wrong. Check your connection, reload the page, and try again."
  },
  "something_went_wrong_d238c551": {
    "message": "Something went wrong"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Something went wrong while sharing your screen."
  },
  "sort_by_e75f9e3e": {
    "message": "Sort By"
  },
  "spades_suit_b37020c2": {
    "message": "Spades (Suit)"
  },
  "square_511eb3b3": {
    "message": "Square"
  },
  "square_cap_9ec88646": {
    "message": "Square Cap"
  },
  "square_cup_b0665113": {
    "message": "Square Cup"
  },
  "square_root_e8bcbc60": {
    "message": "Square Root"
  },
  "square_root_symbol_d0898a53": {
    "message": "Square Root Symbol"
  },
  "square_subset_17be67cb": {
    "message": "Square Subset"
  },
  "square_subset_strict_7044e84f": {
    "message": "Square Subset (Strict)"
  },
  "square_superset_3be8dae1": {
    "message": "Square Superset"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Square Superset (Strict)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "square unordered list"
  },
  "star_8d156e09": {
    "message": "Star"
  },
  "start_over_f7552aa9": {
    "message": "Start Over"
  },
  "start_recording_9a65141a": {
    "message": "Start Recording"
  },
  "steel_blue_14296f08": {
    "message": "Steel Blue"
  },
  "studio_media_options_ee504361": {
    "message": "Studio Media Options"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Studio Media Options Tray"
  },
  "styles_2aa721ef": {
    "message": "Styles"
  },
  "submit_a3cc6859": {
    "message": "Submit"
  },
  "submitting_b90fac62": {
    "message": "Submitting..."
  },
  "subscript_59744f96": {
    "message": "Subscript"
  },
  "subset_19c1a92f": {
    "message": "Subset"
  },
  "subset_strict_8d8948d6": {
    "message": "Subset (Strict)"
  },
  "succeeds_9cc31be9": {
    "message": "Succeeds"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Succeeds Equal"
  },
  "sum_b0842d31": {
    "message": "Sum"
  },
  "superscript_8cb349a2": {
    "message": "Superscript"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Superscript and Subscript"
  },
  "superset_c4db8a7a": {
    "message": "Superset"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superset (Strict)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Supported file types: SRT or WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Switch to pretty HTML Editor"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Switch to raw HTML Editor"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Switch to the html editor"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Switch to the rich text editor"
  },
  "syllabus_f191f65b": {
    "message": "Syllabus"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "System Audio Allowed"
  },
  "system_audio_disabled_c177bd13": {
    "message": "System Audio Disabled"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Arrows"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Table header starting with { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Table starting with { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Table headers should specify scope."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tables should include a caption describing the contents of the table."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tables should include at least one header."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Teal"
  },
  "text_7f4593da": {
    "message": "Text"
  },
  "text_background_color_16e61c3f": {
    "message": "Text Background Colour"
  },
  "text_color_acf75eb6": {
    "message": "Text Colour"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Text is difficult to read without sufficient contrast between the text and the background, especially for those with low vision."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Text larger than 18pt (or bold 14pt) should display a minimum contrast ratio of 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Text (optional)"
  },
  "text_position_8df8c162": {
    "message": "Text Position"
  },
  "text_size_887c2f6": {
    "message": "Text Size"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Text smaller than 18pt (or bold 14pt) should display a minimum contrast ratio of 4.5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "The document preview is currently being processed. Please try again later."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "The first heading on a page should be an H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "The height of Rich Content Area is decreased."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "The height of Rich Content Area is increased."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "The material is in the public domain"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "The material is licensed under Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "The material is subject to an exception - e.g. fair use, the right to quote, or others under applicable copyright laws"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "The pretty html editor is not keyboard accessible. Press Shift O to open the raw html editor."
  },
  "therefore_d860e024": {
    "message": "Therefore"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (Variant)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Thick Downward Arrow"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Thick Left Arrow"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Thick Leftward Arrow"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Thick Right Arrow"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Thick Rightward Arrow"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Thick Upward Arrow"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "This document cannot be displayed within Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "This equation cannot be rendered in Basic View."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "This image is currently unavailable"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "This video may display YouTube ads."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Though your video will have the correct title in the browser, we failed to update it in the database."
  },
  "timebar_a4d18443": {
    "message": "Timebar"
  },
  "title_ee03d132": {
    "message": "Title"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "To Be Posted: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "To Do: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Toggle { summary } group"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Toggle tooltip"
  },
  "tools_2fcf772e": {
    "message": "Tools"
  },
  "top_66e0adb6": {
    "message": "Top"
  },
  "tray_839df38a": {
    "message": "Tray"
  },
  "triangle_6072304e": {
    "message": "Triangle"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Turnstile (Yields)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "type Control F9 to access image options. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "type Control F9 to access link options. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "type Control F9 to access table options. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Unable to determine resource selection url"
  },
  "underline_applied_ae01ec97": {
    "message": "Underline applied"
  },
  "underline_removed_3693e17c": {
    "message": "Underline removed"
  },
  "union_e6b57a53": {
    "message": "Union"
  },
  "unpublished_dfd8801": {
    "message": "unpublished"
  },
  "untitled_16aa4f2b": {
    "message": "Untitled"
  },
  "untitled_efdc2d7d": {
    "message": "untitled"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Up And Left Diagonal Arrow"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Up And Right Diagonal Arrow"
  },
  "up_c553575d": {
    "message": "Up"
  },
  "updated_link_a827e441": {
    "message": "Updated link"
  },
  "upload_document_253f0478": {
    "message": "Upload Document"
  },
  "upload_file_fd2361b8": {
    "message": "Upload File"
  },
  "upload_image_6120b609": {
    "message": "Upload Image"
  },
  "upload_media_ce31135a": {
    "message": "Upload Media"
  },
  "upload_record_media_e4207d72": {
    "message": "Upload/Record Media"
  },
  "uploading_19e8a4e7": {
    "message": "Uploading"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "uppercase alphabetic ordered list"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Uppercase Delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Uppercase Gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Uppercase Lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Uppercase Omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Uppercase Phi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Uppercase Pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "Uppercase Psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "uppercase Roman numeral ordered list"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Uppercase Sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "Uppercase Theta"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Uppercase Upsilon"
  },
  "uppercase_xi_341e8556": {
    "message": "Uppercase Xi"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Upward And Downward Pointing Arrow"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Upward And Downward Pointing Arrow (Thick)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Upward Arrow"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Upward Pointing Triangle"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Usage Right:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Usage Rights (required)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Use arrow keys to navigate options."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Use arrow keys to select a shape."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Use arrow keys to select a size."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Use arrow keys to select a text position."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Use arrow keys to select a text size."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Use arrow keys to select an outline size."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Used by screen readers to describe the content of an { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Used by screen readers to describe the content of an image"
  },
  "used_by_screen_readers_to_describe_the_video_37ebad25": {
    "message": "Used by screen readers to describe the video"
  },
  "user_documents_c206e61f": {
    "message": "User Documents"
  },
  "user_files_78e21703": {
    "message": "User Files"
  },
  "user_images_b6490852": {
    "message": "User Images"
  },
  "user_media_14fbf656": {
    "message": "User Media"
  },
  "vector_notation_cf6086ab": {
    "message": "Vector (Notation)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Vertical Bar (Set Builder Notation)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Vertical Dots"
  },
  "video_options_24ef6e5d": {
    "message": "Video Options"
  },
  "video_options_tray_3b9809a5": {
    "message": "Video Options Tray"
  },
  "video_player_b371005": {
    "message": "Video Player"
  },
  "video_player_for_9e7d373b": {
    "message": "Video player for "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Video player for { title }"
  },
  "view_all_e13bf0a6": {
    "message": "View All"
  },
  "view_ba339f93": {
    "message": "View"
  },
  "view_description_30446afc": {
    "message": "View description"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "View keyboard shortcuts"
  },
  "view_title_description_67940918": {
    "message": "View { title } description"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "View word and character counts"
  },
  "waiting_for_response_1efd0c50": {
    "message": "Waiting for response"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "We couldn’t detect a working microphone connected to your device."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "We couldn’t detect a working webcam connected to your device."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "We couldn’t detect a working webcam or microphone connected to your device."
  },
  "webcam_disabled_30c66986": {
    "message": "Webcam Disabled"
  },
  "webcam_fe91b20f": {
    "message": "Webcam"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Webpages should only have a single H1, which is automatically used by the page''s Title. The first heading in your content should be an H2."
  },
  "what_would_you_like_to_do_6dc0d541": {
    "message": "What would you like to do?"
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "When markup is used that visually formats items as a list but does not indicate the list relationship, users may have difficulty in navigating the information."
  },
  "white_87fa64fd": {
    "message": "White"
  },
  "why_523b3d8c": {
    "message": "Why"
  },
  "width_492fec76": {
    "message": "Width"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Width and height must be numbers"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki Home"
  },
  "word_count_c77fe3a6": {
    "message": "Word Count"
  },
  "words_b448b7d5": {
    "message": "Words"
  },
  "wreath_product_200b38ef": {
    "message": "Wreath Product"
  },
  "writing_assistant_a30ac16a": {
    "message": "Writing Assistant"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Yes"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "You are on a colour palette. To navigate on the palette up, left, down or right, use the ''W'', ''A'', ''S'' and ''D'' buttons respectively"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "You are on a colour slider. To navigate the slider left or right, use the ''A'' and ''D'' buttons respectively"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "You are on an alpha slider. To navigate the slider left or right, use the ''A'' and ''D'' buttons respectively"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "You have unsaved changes in the Icon Maker tray. Do you want to continue without saving these changes?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "You may need to adjust additional headings to maintain page hierarchy."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "You may not upload an empty file."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Your image has been compressed for Icon Maker. Images less than { size } KB will not be compressed."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Your microphone is blocked in the browser settings."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Your webcam and microphone are blocked in the browser settings."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Your webcam is blocked in the browser settings."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Your webcam may already be in use."
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Zoom in image"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Zoom out image"
  }
};
formatMessage.addLocale({
  'en-AU': locale
});